(async()=>{
    const {loadScript: e, loadStyle: t} = await import(window.theme.modules.utils);
    var a = await import(window.theme.modules.baseComponent);
    customElements.define("video-player", class extends a.default {
        elements = {
            player: "[data-player]",
            HTMLPlayer: "video"
        };
        async onIntersect(e) {
            e && !this.player && await this._initPlayer(),
            !e && this.player && this.player.playing && this.player.pause()
        }
        async _initPlayer() {
            t("https://cdn.plyr.io/3.6.8/plyr.css"),
            window.Plyr || await e(window.theme.scripts.Plyr);
            if(this.getAttribute("open-on-click") == "image"){
                          this.player = new window.Plyr(this.hasAttribute("internal") ? this.$HTMLPlayer : this.$player,{fullscreen: {iosNative:true}});

            }else{
                          this.player = new window.Plyr(this.hasAttribute("internal") ? this.$HTMLPlayer : this.$player);

            }
        }
    }
    )
}
)();
